import { ArrowDownRight } from "lucide-react";

export function Partnership({ content, brand, images = [] }) {
  return (
    <section id="contact" className="section partnership-section" data-testid="partnership-section">
      <div className="partnership-panel partnership-slide-panel" data-testid="partnership-panel">
        <div className="partnership-copy" data-testid="partnership-copy">
          <p className="overline" data-testid="partnership-overline">{content.overline}</p>
          <h2 data-testid="partnership-title">{content.title}</h2>
          <p data-testid="partnership-description">
            {content.description}
          </p>

          <div className="hero-actions" data-testid="partnership-cta-group">
            <a className="btn btn-primary" href="#inquiry" data-testid="partnership-contact-us-button">
              {content.buttons[0]} <ArrowDownRight size={16} aria-hidden="true" />
            </a>
            <a className="btn btn-secondary" href="#inquiry" data-testid="partnership-schedule-meeting-button">
              {content.buttons[1]}
            </a>
          </div>
        </div>

        <div className="deck-image-panel partnership-image-panel" data-testid="partnership-image-panel-1">
          {images[0]?.image ? <img src={images[0].image} alt={content.title} data-testid="partnership-image-1" /> : <span>{brand || content.overline}</span>}
        </div>
      </div>
    </section>
  );
}